<div class="h-full w-full p-3 overflow-y-scroll">
  <div class="flex flex-wrap items-center justify-between gap-3">
    <app-breadcrumb [items]="[{ label: 'Dashboard' }]"/>

    <div class="flex items-center gap-2 text-sm">
      <span class="text-gray-400" [class.font-semibold]="!programSpecific" [class.text-gray-800]="!programSpecific" [class.dark:text-white]="!programSpecific">All Programs</span>
      <app-switch [defaultChecked]="programSpecific" (valueChange)="onModeToggle($event)"></app-switch>
      <span class="text-gray-400" [class.font-semibold]="programSpecific" [class.text-gray-800]="programSpecific" [class.dark:text-white]="programSpecific">Program Specific</span>
    </div>
  </div>

  @if (!programSpecific) {
    <div class="mt-4 grid grid-cols-1 gap-4 md:gap-6">
      <app-metrics-card />

      <div class="grid grid-cols-1 gap-4 md:grid-cols-2 md:gap-6">
        <app-env-delta-status-card source="dev" destination="qa" />
        <app-env-delta-status-card source="qa" destination="eu" />
      </div>
    </div>
  } @else if (activeOrganizationId; as orgId) {
    <div class="mt-4 grid grid-cols-1 gap-4 md:gap-6">
      <app-metrics-card [organizationId]="orgId" />

      <div class="grid grid-cols-1 gap-4 md:grid-cols-2 md:gap-6">
        <app-env-delta-status-card source="dev" destination="qa" [organizationId]="orgId" />
        <app-env-delta-status-card source="qa" destination="eu" [organizationId]="orgId" />
      </div>

      <app-translation-status-card [organizationId]="orgId" />
      <app-latest-synchronizations-card [organizationId]="orgId" />
    </div>
  } @else {
    <div class="mt-4 rounded-2xl border border-gray-200 bg-white p-6 text-center text-sm text-gray-500 dark:border-gray-800 dark:bg-white/3 dark:text-gray-400">
      Select an organization to see program-specific insights.
    </div>
  }
</div>
